import React from 'react';
import classes from './PostCardStatusButton.module.scss';
import { PostItemFragment, PostStatus } from '../../../models/graphql';
import classNames from 'classnames';
import { useSettings } from '../../../hooks/useSettings';
import { usePauseSettings } from '../../../hooks/usePauseSettings';
import { PostScheduleViewContext } from '../../../modules/Publish/PostSchedule/PostSchedule.controller';

export type PostCardStatusButtonViewProps = {
  post: PostItemFragment;
  isPostStatusUnqueued: boolean | undefined;
};

// @TODO: consider moving to be a helper
// This determins if the Status button should be present based upon  rules for when it can be
export const shouldShowStatusButton = (
  post: PostItemFragment,
  context: PostScheduleViewContext,
  isPostStatusUnqueued: boolean | undefined
) => {
  let shouldShowStatus = false;

  // We always show for Library
  if (context === PostScheduleViewContext.LIBRARY) shouldShowStatus = true;

  switch (post.status) {
    case PostStatus.PUBLISHED:
    case PostStatus.TRASH:
    case PostStatus.DRAFT:
    case PostStatus.FAILED:
      shouldShowStatus = true;
  }

  if (IsPostPaused(post) || isPostStatusUnqueued) {
    shouldShowStatus = true;
  }

  // Published post in the Queue/List view should not have a status
  if (context === PostScheduleViewContext.LIST && post.status === PostStatus.PUBLISHED) shouldShowStatus = false;

  return shouldShowStatus;
};

// @TODO: consider moving to be a helper
export const IsPostPaused = (post: PostItemFragment) => {
  const { selectedWorkspaceSettings } = useSettings();
  const { isSocialProfilePausedForCategory } = usePauseSettings();
  const isProfilePausedForCategory = isSocialProfilePausedForCategory(post.socialProfile.id, post.category.id);

  return (
    (post.status === PostStatus.ACTIVE &&
      (selectedWorkspaceSettings?.queuesPaused || isProfilePausedForCategory || post.category.seasonallyPaused)) ||
    false
  );
};

export const PostCardStatusButtonView = ({
  post,
  isPostStatusUnqueued
}: PostCardStatusButtonViewProps): JSX.Element => {
  const isPaused = IsPostPaused(post);

  const statusButtonLabel = isPaused
    ? 'Paused'
    : isPostStatusUnqueued
    ? 'Unqueued'
    : post.status === PostStatus.PUBLISHED
    ? 'Published'
    : post.status === PostStatus.ACTIVE
    ? 'Active'
    : post.status === PostStatus.TRASH
    ? 'Trash'
    : post.status === PostStatus.FAILED
    ? 'Failed'
    : post.status === PostStatus.DRAFT
    ? 'Draft'
    : post.status;

  const isRedStatusButton =
    statusButtonLabel === 'Paused' || post.status === PostStatus.TRASH || post.status === PostStatus.FAILED;

  const statusButtonClasses = classNames(classes.StatusButton, {
    [classes.StatusButtonNoMedia]: !post.photos.length && !post.videos.length,
    [classes.StatusButtonRed]: isRedStatusButton
  });

  return (
    <div className={'cell shrink'}>
      <div className={statusButtonClasses}>{statusButtonLabel}</div>
    </div>
  );
};
